import { ErrorCode } from "@models/enums/error.codes";
import { ErrorBase } from "./error-base.model";


export class HttpError extends ErrorBase {
  override errorObject?: any;
  override date?: Date;
  constructor(public message: string, public errorCode: ErrorCode, public httpStatusCode: number, public url : string) {
    super();
  }

  override toString() {
    return `Error Message : ${this.message}, Error Code : ${this.errorCode}, Http Status Code : ${this.httpStatusCode}`;
  }
}
